export default class languageSelect {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                loadedOptions: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$timeout', '$modal', 'Language',
                (scope, element, attr, $timeout, $modal, Language) => {
                var languages = null;
                $timeout(() => {
                    var languageSelect = $(element).selectize({
                        valueField: 'id',
                        labelField: 'language',
                        searchField: 'language',
                        plugins: ['remove_button'],
                        preload: true,
                        create: false,

                        load: (query, callback) => {
                            if (! languages) {
                                Language.all().then((result) => {
                                    languages = result.languages;
                                    callback(languages)
                                })
                            }

                            if (! languages && query) {
                                var filteredLanguages = languages.filter((language) => {
                                    var regex = new RegExp(query, 'i');
                                    if (language.language.search(regex)) {
                                        return language
                                    }
                                });

                                callback(filteredLanguages)
                            }
                        }
                    });


                    scope.$watch('loadedOptions', (newVal, oldVal) => {
                        if (! newVal) {
                            return
                        }

                        if (! languages) {
                            Language.all().then((result) => {
                                var filteredLanguages = result.languages.filter((language) => {
                                    var match = null;
                                    newVal.map((id) => {
                                        if (id == language.id) {
                                            match = language
                                        }
                                    });
                                    if (match) {
                                        return match
                                    }
                                });

                                _.map(filteredLanguages, (language) => {
                                    $timeout(() => {
                                        languageSelect[0].selectize.addOption({ id: language.id, language: language.language });
                                        languageSelect[0].selectize.addItem(language.id)
                                    })
                                })
                            })
                        }

                    })
                })
            }]
        }
    }
}